<template>
  <div class="my-2" v-if="app.length">
    <van-swipe :autoplay="6000" indicator-color="white" class="mx-4 rounded-lg shadow-md">
      <van-swipe-item v-for="(img, i) in app" :key="i" class="bg-white relative" :class="isCompact ? 'h-32' : 'h-48'">
        <template v-if="img.type == 'image'">
          <van-image class="object-center h-full w-full" :src="img.src" fit="cover"></van-image>
        </template>
        <template v-else-if="img.type == 'note'">
          <div class="w-full h-full relative bg-sky-100 p-4">
            <v-icon
              icon="ph:megaphone-simple-duotone"
              class="text-6xl text-sky-300 absolute bottom-4 right-10 rotate-12 scale-[250%]"
            />
            <strong :class="isCompact ? 'text-md' : 'text-xl'">{{ img.title }}</strong>
            <p class="opacity-75 whitespace-pre-line" :class="isCompact ? 'text-sm' : 'text-md'">
              {{ img.description }}
            </p>
          </div>
        </template>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
  import { appCustom } from "@/states/app";

  export default {
    props: {
      isCompact: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      app() {
        return appCustom.banners;
      }
    }
  };
</script>
